import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { quoteFormSelector } from 'ctm-selectors';
import moment from 'moment';
import { convertStringCase, getLicenceTypeLabel } from 'ctm-components/components/utils';
import { getFeatureFlag } from 'ctm-selectors/selectors/base';
import _ from 'lodash';
import { SummaryTable } from '../summary_table';

const path = 'youngest_driver';

const _SummaryYoungerDriver = (props) => {
    const { youngerDriverGender, youngerDriverDob, youngerDriverLicenceAge, youngerDriverLicenceType, hasYoungerDriver,
        isUpdated, hasAssumedYoungerDriverLicenceType } = props;
    const hasYoungerDriverAssumedQuestions = hasAssumedYoungerDriverLicenceType;

    const youngerDriver = [
        {
            title: 'Gender',
            value: convertStringCase(youngerDriverGender.toLowerCase(), 'title')
        },
        {
            title: 'Date of birth',
            value: youngerDriverDob ? moment(youngerDriverDob).format('DD/MM/YYYY') : ''
        },
        {
            title: 'Licence type',
            value: getLicenceTypeLabel(youngerDriverLicenceType) ?? 'Required',
            userToVerify: hasAssumedYoungerDriverLicenceType && !youngerDriverLicenceType
        },
        {
            title: 'Licence age',
            value: youngerDriverLicenceAge
        }
    ];

    const noDriver = [
        {
            title: 'Younger driver',
            value: 'None'
        }
    ];

    return (
        hasYoungerDriver
            ? (
                <SummaryTable
                    isUpdated={isUpdated}
                    path={path}
                    titleLabel={`Younger Driver ${isUpdated ? '- Updated' : ''}`}
                    tableContent={_.flatten(youngerDriver.filter((item) => !!item))}
                    verifyBucket={hasYoungerDriverAssumedQuestions}
                />
            )
            : (
                <SummaryTable
                    isUpdated={isUpdated}
                    path={path}
                    titleLabel={`Younger Driver ${isUpdated ? '- Updated' : ''}`}
                    tableContent={noDriver}
                />
            )
    );
};

const mapStateToProps = (state) => {
    return {
        youngerDriverGender: quoteFormSelector(state).getIn(['coverDetail', 'youngestDriver', 'gender']) || '',
        youngerDriverDob: quoteFormSelector(state).getIn(['coverDetail', 'youngestDriver', 'dob']) || '',
        youngerDriverLicenceAge: quoteFormSelector(state).getIn(['coverDetail', 'youngestDriver', 'licenceAge']) || '',
        youngerDriverLicenceType: quoteFormSelector(state).getIn(['coverDetail', 'youngestDriver', 'licenceType']),
        // eslint-disable-next-line max-len
        hasYoungerDriver: quoteFormSelector(state).getIn(['coverDetail', 'hasYoungerDriver']) === true || quoteFormSelector(state).getIn(['coverDetail', 'hasYoungerDriver']) === 'Y',
        isUpdated: state.getIn(['vertical', 'quote', 'form', `summaryPageEdit${path}`]),
        assumedQuestions: state.getIn(['vertical', 'quote', 'form', 'assumedQuestions']) ?? [],
        hasAssumedYoungerDriverLicenceType: state.getIn(['vertical', 'quote', 'form', 'hasAssumedQuestions', 'hasAssumedYoungerDriverLicenceType'])
    };
};

_SummaryYoungerDriver.propTypes = {
    youngerDriverGender: PropTypes.string,
    youngerDriverDob: PropTypes.string,
    youngerDriverLicenceAge: PropTypes.string,
    hasYoungerDriver: PropTypes.bool,
    isUpdated: PropTypes.bool,
    hasAssumedYoungerDriverLicenceType: PropTypes.bool
};

const SummaryYoungerDriver = connect(
    mapStateToProps,
)(_SummaryYoungerDriver);

export { _SummaryYoungerDriver, SummaryYoungerDriver };
